export const SchoolingEnum = {
  SemOuMenosDeUmAno: 'Sem instrução ou menos de 1 ano de estudo',
  EnsinoFundamental1: 'Ensino fundamental 1',
  EnsinoFundamental2: 'Ensino fundamental 2',
  EnsinoMedio: 'Ensino médio',
  EnsinoTecnico: 'Ensino técnico',
  EnsinoSuperior: 'Ensino superior',
  NotInformed: 'Não informado',
};
